var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.path } },
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "w-card",
                    { staticClass: "grow" },
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("favv.title"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { sm: "12", md: "6" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("favv.favv-sku"),
                                    },
                                    model: {
                                      value:
                                        _vm.config.FavvConfig.FavvProductSku,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config.FavvConfig,
                                          "FavvProductSku",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.FavvConfig.FavvProductSku",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { sm: "12", md: "6" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("favv.favv-cost"),
                                    },
                                    model: {
                                      value: _vm.config.FavvConfig.FavvCost,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config.FavvConfig,
                                          "FavvCost",
                                          $$v
                                        )
                                      },
                                      expression: "config.FavvConfig.FavvCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("bebat.title"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { sm: "12", md: "12" } },
                                [
                                  _c("app-translation-input", {
                                    attrs: { "force-input": true },
                                    model: {
                                      value: _vm.config.TextBebat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "TextBebat", $$v)
                                      },
                                      expression: "config.TextBebat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("labels")))]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "label-for-custom-vat-exclusive-tax"
                                      ),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.config
                                          .ProductCustomVatExclusiveTaxLabelName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "ProductCustomVatExclusiveTaxLabelName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.ProductCustomVatExclusiveTaxLabelName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: _vm.$ct(
                                        "label-for-custom-vat-inclusive-tax"
                                      ),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.config
                                          .ProductCustomVatInclusiveTaxLabelName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "ProductCustomVatInclusiveTaxLabelName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "config.ProductCustomVatInclusiveTaxLabelName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }